<app-deprecated-modal-form
    #modalForm
    [form]="positionForm"
    (save)="onCreate(positionForm.position, positionForm)"
    headerText="{{ 'company.positions.addPositionDialogHeader' | translate }}"
>
    <app-position-form #positionForm></app-position-form>
</app-deprecated-modal-form>

<div class="page-container" [class.loading]="isLoading">
    <app-header title="Company" [menuService]="companyMenuService">
        <div class="buttons">
            <ui-button type="primary" (click)="modalForm.show()" *permission="createPermission">
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'company.positions.createPositionButtonLabel' | translate }}
            </ui-button>
        </div>
    </app-header>

    <app-table [table]="table" class="table">
        <app-empty-state label="company.positions.noPositionsFoundMessage"></app-empty-state>
    </app-table>
</div>
